import { render, staticRenderFns } from "./navigationBlock.vue?vue&type=template&id=2bc83258&"
import script from "./navigationBlock.vue?vue&type=script&lang=js&"
export * from "./navigationBlock.vue?vue&type=script&lang=js&"
import style0 from "./navigationBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports